import { render, staticRenderFns } from "./FLabel.vue?vue&type=template&id=6a7cec44&"
import script from "./FLabel.vue?vue&type=script&lang=js&"
export * from "./FLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports